import React from 'react';

// Small inline platform badge for a user: Apple logo for iOS, Android robot
// for Android. Renders nothing when the platform is unknown.
const ICONS = {
  ios: {
    label: 'iOS',
    color: '#6b7280',
    path: 'M11.62 4.28c.62-.75 1.05-1.78.93-2.83-.9.04-2 .6-2.65 1.35-.58.66-1.09 1.72-.95 2.73 1.01.08 2.03-.51 2.67-1.25zm2.4 8.4c.02 2.6 2.28 3.46 2.3 3.47-.02.06-.36 1.24-1.19 2.45-.72 1.05-1.46 2.1-2.63 2.12-1.15.02-1.52-.68-2.84-.68-1.31 0-1.72.66-2.81.7-1.13.04-2-1.13-2.72-2.18-1.47-2.14-2.6-6.04-1.09-8.68.75-1.31 2.09-2.14 3.55-2.16 1.11-.02 2.15.75 2.83.75.67 0 1.94-.92 3.27-.79.56.02 2.12.23 3.13 1.7-.08.05-1.87 1.1-1.85 3.3z',
  },
  android: {
    label: 'Android',
    color: '#3ddc84',
    path: 'M17.53 8.16l1.32-2.29a.27.27 0 00-.1-.37.27.27 0 00-.37.1l-1.34 2.32A8.14 8.14 0 0012 6.99c-1.77 0-3.42.36-5.04.93L5.62 5.6a.27.27 0 00-.37-.1.27.27 0 00-.1.37l1.32 2.29C3.9 9.55 2.13 12.16 2 15.18h20c-.13-3.02-1.9-5.63-4.47-7.02zM7.4 12.61a.84.84 0 01-.84-.84c0-.46.38-.83.84-.83.46 0 .83.37.83.83 0 .46-.37.84-.83.84zm9.2 0a.84.84 0 01-.84-.84c0-.46.38-.83.84-.83.46 0 .83.37.83.83 0 .46-.37.84-.83.84z',
  },
};

const PlatformIcon = ({ platform, size = 14 }) => {
  const icon = ICONS[platform];
  if (!icon) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={icon.color}
      role="img"
      aria-label={icon.label}
      style={{ flexShrink: 0, verticalAlign: 'text-bottom' }}
    >
      <title>{icon.label}</title>
      <path d={icon.path} />
    </svg>
  );
};

export default PlatformIcon;
